'use strict';

// export this package's api
module.exports = require('./Animate');


//////////////////
// WEBPACK FOOTER
// ./~/_rc-animate@2.3.6@rc-animate/lib/index.js
// module id = 106
// module chunks = 0